import type { HttpClient } from './http';
import type {
  AdminMembership,
  AdminOrganization,
  AdminOrganizationUserCountsResponse,
  FeatureFlagsAdminMetadata,
  OrganizationUserCount,
} from './types';

export interface AdminApi {
  getAdminMetadata(): Promise<FeatureFlagsAdminMetadata>;
  getOrganizationUserCounts(): Promise<OrganizationUserCount[]>;
  createOrganization(input: {
    name: string;
    description?: string;
  }): Promise<AdminOrganization>;
  assignUserToOrganization(
    organizationId: string,
    userId: string
  ): Promise<AdminMembership>;
  removeUserFromOrganization(
    organizationId: string,
    userId: string
  ): Promise<void>;
  restoreUserToOrganization(
    organizationId: string,
    userId: string
  ): Promise<void>;
}

export function createAdminApi(http: HttpClient): AdminApi {
  return {
    getAdminMetadata: () =>
      http.get<FeatureFlagsAdminMetadata>('/admin/metadata'),
    getOrganizationUserCounts: async () => {
      const res = await http.get<AdminOrganizationUserCountsResponse>(
        '/admin/organizations/user-counts'
      );
      return res.organizationUserCounts ?? [];
    },
    createOrganization: (input) =>
      http.post<AdminOrganization>('/admin/organizations', input),
    assignUserToOrganization: (organizationId, userId) =>
      http.post<AdminMembership>(
        `/admin/organizations/${organizationId}/users`,
        {
          userId,
        }
      ),
    removeUserFromOrganization: async (organizationId, userId) => {
      await http.delete<void>(
        `/admin/organizations/${organizationId}/users/${userId}`
      );
    },
    restoreUserToOrganization: async (organizationId, userId) => {
      await http.post<void>(
        `/admin/organizations/${organizationId}/users/${userId}/restore`
      );
    },
  };
}
